import React from 'react';
import TreeView from '@zippytech/react-toolkit/TreeView';
import '@zippytech/react-toolkit/TreeView/index.css';
import { dispatch } from '@rematch/core';
import { source } from 'react-aim';
import { withRouter } from 'react-router-dom';
import attachedLabelToTree from '../../../../helpers/attachedLabelToTree'
import LabelWithCount from '../../../common/LabelWithCount'

@source({
  mouseEnter: (props, component) => {
    dispatch.app.setHelpContext(props.name);
  }
})

class OrganizationTree extends React.Component {

  constructor(props) {
    super(props);
    this.state = {}
  }

  nodeStyle = (nodeProps) => {
    if (this.props.orgUniqueId && nodeProps.node._id && nodeProps.node._id.toString() === this.props.orgUniqueId.toString() && this.props.mainAreaContext !== 'Events') {
      return { color: '#7FC4FA', fontFamily: 'montserrat-semibold' }
    } else {
      return { color: '#6b6b6b', fontFamily: 'montserrat-normal', fontWeight: 'normal' }
    }
  }

  async onSelectionChange(map) {
    dispatch.app.showToolbar(true)
    dispatch.app.setCollapsedResourcePaneIndexTemp(null)
    dispatch.organizationUnit.showResourecePane(null);
    dispatch.organizationUnit.landingPageFlagSet(false);
    dispatch.community.addMainAreaContext('ORGANIZATION');
    dispatch.organizationUnit.addSelectedSubOrg(map.node);
    dispatch.users.storeUnitId(map.node._id);
    const history = this.props.history;
    let query = {
      $sort: { createdAt: 1 },
      $skip: 0,
      $limit: this.props.teamsListViewFlag ? 10 : 50
    }
    if (this.props.selectedOrganisation.id === map.node._id) {
      let payload = {
        query: query,
        organizationId: this.props.selectedOrganisation.id,
        accountId: this.props.match.params.accountId
      };
      await dispatch.organizationUnit.getAssignedSubOrgAsync(payload);
      await dispatch.organizationUnit.getOrgByIdAsync(this.props.match.params.workspaceId);
    }
    else {
      let payload = {
        query: query,
        teamId: map.node._id
      };
      await dispatch.organizationUnit.getSubOrgByParentIdAsync(payload);
      await dispatch.organizationUnit.getSubOrgByIdAsync(map.node._id);
    }
    history.push(`/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_cm/team/${map.node._id}`);
    dispatch.organizationTab.getUsersTreeAsync({ id: map.node._id, accountId: this.props.match.params.accountId });
    let payload = {
      query: query,
      organizationId: this.props.selectedOrganisation.id,
      referenceId: map.node._id
    };
    dispatch.invite.getInvitesAsync(payload);


  }

  componentWillMount() {
    dispatch.users.storeUnitId(this.props.match.params.workspaceId);
    let query = {
      $sort: { createdAt: 1 },
      $skip: 0,
      $limit: this.props.teamsListViewFlag ? 10 : 50
    }
    let payload = {
      query: query,
      organizationId: this.props.selectedOrganisation.id,
      referenceId: this.props.selectedOrganisation.id
    };
    dispatch.invite.getInvitesAsync(payload);
    dispatch.organizationTab.getOrgnizationUnitAsync(this.props.selectedOrganisation.id);
    dispatch.organizationTab.getUsersTreeAsync({ id: this.props.selectedOrganisation.id, accountId: this.props.match.params.accountId });
  }

  componentWillReceiveProps(newProps) {
    if (this.props.nodes !== newProps.nodes) {


      const updateNodeLabels = (nodes) => {
        return nodes.map((node) => {
          node.label = <LabelWithCount label={node.label} count={node.nodes && node.nodes.length} />;
          if (node.nodes && node.nodes.length !== 0) {
            node.nodes = updateNodeLabels(node.nodes);
          }
          return node;
        });
      };
      const updatedNodes = updateNodeLabels(newProps.nodes)
      // Below code block is written for KLM-8966
      let nl = updatedNodes.sort((x, y) => {
        if(x.name < y.name) {
          return -1
        }
        if(x.name > y.name) {
          return 1
        }
        return 0
      })
      this.setState({ subTeamsList: nl })
    }
  }

  render() {

    const treeList = [
      {
        label: <strong> <LabelWithCount labelClass="bg-blue" label={`Teams - ${this.props.selectedOrganisation.name}`} count={this.state.subTeamsList && this.state.subTeamsList.length ? this.state.subTeamsList.length : 0} /></strong>,
        nodes: this.state.subTeamsList,
        _id: this.props.match.params.workspaceId,
        parentOrganizationId: this.props.match.params.workspaceId,
        value: 'teams'
      }
    ];


    // let components = attachedLabelToTree(treeList)

    return (
      <TreeView
        className="browserPane tree-ellipsis"
        defaultCollapsedDepth={1}
        nodeStyle={this.nodeStyle}
        enableSelection={true}
        enableHoverStyle={false}
        singleSelect={true}
        onSelectionChange={(selectedMap) => { this.onSelectionChange(selectedMap) }}
        dataSource={treeList}
        ref={ref => this.props.nodes.treeRef = ref}
        enableKeyboardNavigation={false}
      />
    );
  }
}
export default withRouter(OrganizationTree)
